import type { Currency } from "@opensea/app-kit"
import { useChains, useCurrencies } from "@opensea/app-kit"
import { createContext, useContext, useState } from "react"
import { useChainArch } from "../../../../polychain/hooks"
import { useChainId } from "../../../../polychain/hooks/useChainId"

type SendQuoteContextType = {
  currency: Currency
  setCurrency: (currency: Currency) => void
}

const SendQuoteContext = createContext<SendQuoteContextType>({
  currency: {} as Currency,
  setCurrency: () => {},
})
type SendProviderProps = {
  children: React.ReactNode
}

export function SendProvider({ children }: SendProviderProps) {
  const chainId = useChainId()
  const chainArch = useChainArch()
  const { getNativeCurrency, getChainIdentifier } = useChains()
  const { getCurrencyStrict } = useCurrencies()

  const chainIdentifier = getChainIdentifier(chainId ?? 1, chainArch)
  const nativeCurrency = getCurrencyStrict(
    getNativeCurrency(chainIdentifier ?? "ethereum"),
  )

  const [currency, setCurrency] = useState(nativeCurrency)

  return (
    <SendQuoteContext.Provider value={{ currency, setCurrency }}>
      {children}
    </SendQuoteContext.Provider>
  )
}

export const useSendQuote = () => {
  const context = useContext(SendQuoteContext)
  return context
}
